export var LISTBOX_EVENT_REASON = Object.freeze({
  CLICK: 'click',
  HOVER: 'hover',
  TYPEAHEAD: 'typeahead',
  ARROW_DOWN: 'arrow down',
  ARROW_UP: 'arrow up',
  HOME: 'home',
  END: 'end',
  SPACE: 'space',
  ENTER: 'enter'
});